import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { Store } from '@ngrx/store';
import { FormControlState, SetValueAction } from 'ngrx-forms';
import { dateValueConverter } from '@macs-frontend/features/shared';
import { DatepickerComponent } from '@macs-frontend/features/shared/components/datepicker/datepicker.component';

@Component({
  selector: 'md-table-filter-date',
  templateUrl: 'table-filter-date.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['table-filter-date.component.scss'],
})
export class TableFilterDateComponent extends BaseComponent {
  @Output() selected = new EventEmitter();
  // @ts-expect-error
  @Input() ngrxFormControl: FormControlState<any>;
  // @ts-expect-error
  @ViewChild('datepicker') datepicker: DatepickerComponent;

  show = false;
  readonly dateValueConverter = dateValueConverter;

  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    // makeSelectable(this, { cdr, store$ });
  }

  showFilter() {
    this.show = true;
    this.datepicker.openPicker();
  }

  hideFilter() {
    this.show = false;
  }

  onClearClick() {
    this.store$.dispatch(new SetValueAction(this.ngrxFormControl.id, null));
    this.selected.emit();
    this.cdr.markForCheck();
  }

  emitSelected() {
    this.selected.emit();
  }
}
